// import React from 'react';
// import { AppBar, Box, Toolbar, IconButton, Typography, InputBase, Badge } from '@mui/material';
// import { Search as SearchIcon, Notifications as NotificationsIcon, AccountCircle } from '@mui/icons-material';
// import { Navigate, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import StartTimerButton from "../components/StartTimerButton";

// const NavBar = ({ sidebarOpen }) => {
//   const navigate = useNavigate();
//   const isAuthenticated = useSelector((state) => state.isAuthenticated);

//   const { user } = useSelector((state) => state.userLoaded);
//   const handleProfileClick = () => {
//     navigate('/profile');
//   };
//   if (!user && !isAuthenticated) {
//     return <Typography>Loading...</Typography>;
//   }
//   return (
//     <AppBar
//       position="fixed"
//       sx={{
//         backgroundColor: '#F5F5F5', color: '#2C3E50',
//         width: `calc(100% - ${sidebarOpen ? '200px' : '60px'})`,
//         marginLeft: sidebarOpen ? '200px' : '60px',
//         transition: 'width 0.3s ease, margin-left 0.3s ease'
//       }}
//     >
//       <Toolbar>
//         <img src="/lp-logo.png" alt="Logo" style={{ width: '70px' }} />

//         <div style={{ flexGrow: 1, position: 'relative' }}>
//           {/* <div style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//             <SearchIcon />
//           </div> */}
//           {/* <InputBase
//             placeholder="Search…"
//             inputProps={{ 'aria-label': 'search' }}
//             style={{ paddingLeft: '40px', width: '100%' }}
//           /> */}
//         </div>
//         {/* <IconButton color="inherit">
//           <Badge badgeContent={4} color="error">
//             <NotificationsIcon />
//           </Badge>
//         </IconButton> */}
//         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//           <StartTimerButton />
//         </Box>
//         <IconButton color="inherit" sx={{borderRadius: 0 }} onClick={handleProfileClick}>
//           <AccountCircle />
//           <Typography variant="body1" style={{ marginLeft: '10px' }}>{user.firstName} {user.lastName}</Typography>
//         </IconButton>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default NavBar;
import React, { useState } from "react";
import { format } from "date-fns";

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  FormControl,
  FormControlLabel,
  FormGroup,
  Avatar,
  TextField,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import StartTimerButton from "../components/StartTimerButton";
import CurrentWorkingFile from "../components/CurrentWorkingFile";
import { fetchFiles } from "../redux/actions/fileActions";
import { fetchRelationships } from "../redux/actions/relationshipActions";
import { listAppointments } from "../redux/actions/appointmentActions";
import { listTimesheets } from "../redux/actions/timesheetActions";
import { getAllDocuments } from "../redux/actions/documentActions";
import { fetchTasks } from "../redux/actions/taskActions";
import { listSalesPayments } from "../redux/actions/salesPaymentActions";
import { getSalesDocuments } from "../redux/actions/salesDocumentActions";
import { useEffect } from "react";
import { setSelectedCase } from "../redux/slices/caseSlice";
import { smallBold } from "../styles/typography";
import { textFieldStyles } from "../styles/textFieldStyles";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { Badge, Menu, MenuItem } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LanguageSelector from "./LanguageSelector";
import axios from "../utils/axiosConfig";
import io from "socket.io-client";
import { fetchNotifications, setNotifications } from "../redux/actions/notificationActions";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { useTranslation } from 'react-i18next';
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { useRef } from "react";

// const socket = io('http://localhost:5000'); // in NavBar.js or equivalent
const NavBar = ({ sidebarOpen }) => {
  const { t } = useTranslation(['common', 'buttons']);
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.isAuthenticated);
  const { user } = useSelector((state) => state.userLoaded);
  const [anchorEl, setAnchorEl] = useState(null);
  const { notifications } = useSelector((state) => state.notifications);
  // const user = useSelector((state) => state.userLoaded.user);

  const location = useLocation();
  const dispatch = useDispatch();
  const selectedCaseId = useSelector((state) => state.case.selectedCaseId);
  const searchBoxRef = useRef(null);

  useEffect(() => {
    dispatch(fetchFiles());
    dispatch(fetchRelationships());
    dispatch(listAppointments());
    dispatch(getAllDocuments());
    dispatch(fetchTasks());
    dispatch(listSalesPayments());
    dispatch(getSalesDocuments());
    dispatch(listTimesheets());
  }, [dispatch]);

  const [searchTerm, setSearchTerm] = useState("");

  // Redux states
  const { files } = useSelector((state) => state.fileList);
  const { relationships } = useSelector((state) => state.relationshipList);
  const { documents } = useSelector((state) => state.documentList);
  const { tasks } = useSelector((state) => state.taskList);
  const { appointments } = useSelector((state) => state.appointmentList);
  const { timesheets } = useSelector((state) => state.timesheetList);
  const { salesDocuments } = useSelector((state) => state.salesDocumentList);
  const { salesPayments } = useSelector((state) => state.salesPaymentList);
  // Helper to normalize strings
  const normalizeString = (str) => str ? str.replace(/\s+/g, "").toLowerCase() : "";

  const handleNavigation = (fileId) => {
    navigate(`/files/${fileId}/overview`);
  };

  // Filter files based on the user role
  const userFiles = files?.filter((file) => {
    if (user?.role === "Manager") {
      return true;
    } else if (user?.role === "Responsible Lawyer") {
      return file.officeMembers.some(
        (member) =>
          member.member._id === user.relationship &&
          member.role === "Responsible Lawyer"
      );
    } else if (user?.role === "Assistant Lawyer") {
      return file.officeMembers.some(
        (member) =>
          member.member._id === user.relationship &&
          member.role === "Treating Lawyer"
      );
    }
    return false;
  });

  // Filter Files by searchTerm
  const filteredFiles = userFiles?.filter((file) => {
    if (!searchTerm) return true;
    const partiesNames =
      file?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    const officeMemberNames =
      file.officeMembers
        ?.map((member) => member.member?.firstName + member.member?.lastName)
        .join("") || "";
    return (
      normalizeString(file.fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(file.name).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(officeMemberNames).includes(normalizeString(searchTerm))
    );
  });

  // Filter Relationships by searchTerm
  const filteredRelationships = relationships?.filter((rel) => {
    if (!searchTerm) return true;
    const fullName = `${rel.firstName || ""} ${rel.middleName || ""} ${
      rel.lastName || ""
    } ${rel.businessName || ""}`;
    return normalizeString(fullName).includes(normalizeString(searchTerm));
  });

  // Filter Documents
  const filteredDocuments = documents?.filter((doc) => {
    const partiesNames =
      doc.caseFile?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    if (!searchTerm) return true;
    const caseName = doc.caseFile?.name || "";
    const fileNo = doc.case?.fileNo || "";
    const ownerName = `${doc.owner?.firstName || ""} ${
      doc.owner?.middleName || ""
    } ${doc.owner?.lastName || ""}`;
    return (
      normalizeString(doc.title).includes(normalizeString(searchTerm)) ||
      normalizeString(caseName).includes(normalizeString(searchTerm)) ||
      normalizeString(fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(ownerName).includes(normalizeString(searchTerm))
    );
  });

  // Filter Appointments
    const filteredAppointments = appointments?.filter((appt) => {
    const partiesNames =
      appt.case?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    if (!searchTerm) return true;
    const ownerName = `${appt.owner?.firstName || ""} ${
      appt.owner?.middleName || ""
    } ${appt.owner?.lastName || ""}`;
    const caseName = appt.case?.name || "";
    const fileNo = appt.case?.fileNo || "";
    return (
      normalizeString(ownerName).includes(normalizeString(searchTerm)) ||
      normalizeString(caseName).includes(normalizeString(searchTerm)) ||
      normalizeString(fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(appt.subject).includes(normalizeString(searchTerm))
    );
  });

  // Filter Tasks
  const filteredTasks = tasks?.filter((task) => {
    const partiesNames =
      task.case?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    if (!searchTerm) return true;
    const ownerName = `${task.owner?.firstName || ""} ${
      task.owner?.middleName || ""
    } ${task.owner?.lastName || ""}`;
    const caseName = task.case?.name || "";
    const fileNo = task.case?.fileNo || "";
    const matchesSearchTerm =
      normalizeString(ownerName).includes(normalizeString(searchTerm)) ||
      normalizeString(caseName).includes(normalizeString(searchTerm)) ||
      normalizeString(fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(task.subject).includes(normalizeString(searchTerm));
    return (
      (user.role === "Manager" ||
        userFiles.some((file) => file._id === task.case?._id)) &&
      matchesSearchTerm
    );
  });

  // Filter Timesheets
  const filteredTimesheets = timesheets?.filter((timesheet) => {
    // Safeguard against undefined/null timesheet
    if (!timesheet) {
      console.warn("Undefined or null timesheet encountered:", timesheet);
      return false;
    }

    // Safely access nested properties
    const partiesNames =
      timesheet.fileCase?.parties
        ?.map(
          (party) =>
            (party.name?.firstName || "") +
            (party.name?.lastName || "") +
            (party.name?.businessName || "")
        )
        .join("") || "";

    const matchesSearchTerm = searchTerm
      ? (timesheet.description &&
          normalizeString(timesheet.description).includes(
            normalizeString(searchTerm)
          )) ||
        (timesheet.owner &&
          normalizeString(
            `${timesheet.owner?.firstName || ""} ${
              timesheet.owner?.middleName || ""
            } ${timesheet.owner?.lastName || ""}`
          ).includes(normalizeString(searchTerm))) ||
        (timesheet.fileCase &&
          normalizeString(timesheet.fileCase?.name || "").includes(
            normalizeString(searchTerm)
          )) ||
        normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
        (timesheet.fileCase &&
          normalizeString(timesheet.fileCase?.fileNo || "").includes(
            normalizeString(searchTerm)
          )) ||
        (timesheet.type &&
          normalizeString(timesheet.type || "").includes(
            normalizeString(searchTerm)
          ))
      : true;

    return (
      userFiles?.some((file) => file._id === timesheet.fileCase?._id) &&
      matchesSearchTerm
    );
  });

  // Filter Sales Documents
  const filteredSalesDocuments = salesDocuments?.filter((doc) => {
    const partiesNames =
      doc.case?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    if (!searchTerm) return true;
    const fromName = `${doc.from?.firstName || ""} ${
      doc.from?.middleName || ""
    } ${doc.from?.lastName || ""} ${doc.from?.businessName || ""}`;
    const toName = `${doc.to?.firstName || ""} ${doc.to?.middleName || ""} ${
      doc.to?.lastName || ""
    } ${doc.to?.businessName || ""}`;
    const caseName = doc.case?.name || "";
    const fileNo = doc.case?.fileNo || "";
    const matchesSearchTerm =
      normalizeString(fromName).includes(normalizeString(searchTerm)) ||
      normalizeString(toName).includes(normalizeString(searchTerm)) ||
      normalizeString(fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(caseName).includes(normalizeString(searchTerm));
    return (
      (user.role === "Manager" ||
        userFiles.some((file) => file._id === doc.case?._id)) &&
      matchesSearchTerm
    );
  });

  // console.log("Appointments", filteredAppointments);

  // Filter Sales Payments
  const filteredSalesPayments = salesPayments?.filter((payment) => {
    const partiesNames =
      payment.case?.parties
        ?.map(
          (party) =>
            party.name?.firstName +
            party.name?.lastName +
            party.name?.businessName
        )
        .join("") || "";
    if (!searchTerm) return true;
    const fromName = `${payment.from?.firstName || ""} ${
      payment.from?.middleName || ""
    } ${payment.from?.lastName || ""} ${payment.from?.businessName || ""}`;
    const toName = `${payment.to?.firstName || ""} ${
      payment.to?.middleName || ""
    } ${payment.to?.lastName || ""} ${payment.to?.businessName || ""}`;
    const caseName = payment.case?.name || "";
    const fileNo = payment.case?.fileNo || "";
    const matchesSearchTerm =
      normalizeString(fromName).includes(normalizeString(searchTerm)) ||
      normalizeString(toName).includes(normalizeString(searchTerm)) ||
      normalizeString(fileNo).includes(normalizeString(searchTerm)) ||
      normalizeString(partiesNames).includes(normalizeString(searchTerm)) ||
      normalizeString(caseName).includes(normalizeString(searchTerm));
    return (
      (user.role === "Manager" ||
        userFiles.some((file) => file._id === payment.case?._id)) &&
      matchesSearchTerm
    );
  });

  // useEffect(() => {
  //   if (location.state?.caseId) {
  //     dispatch(setSelectedCase(location.state.caseId));
  //   }
  // }, [location.state?.caseId, dispatch]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setSearchTerm(""); // Clear search term to hide the results
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCaseChange2 = (event, newValue) => {
    dispatch(setSelectedCase(newValue ? newValue._id : ""));
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };

  useEffect(() => {
    if (user?._id) {
      dispatch(fetchNotifications(user._id));
    }
  }, [user, dispatch]);

  const handleMarkAsRead = async (notifId) => {
    await axios.put(`/api/notifications/${notifId}/markAsRead`);
    dispatch(
      setNotifications(
        notifications.map((n) =>
          n._id === notifId ? { ...n, isRead: true } : n
        )
      )
    );
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleIgnore = async (notifId) => {
    await axios.delete(`/api/notifications/${notifId}`);
    dispatch(setNotifications(notifications.filter((n) => n._id !== notifId)));
  };

  if (!user && !isAuthenticated) {
    return <Typography>{t('common:loading')}</Typography>;
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "white",
        color: "#2C3E50",
        width: `calc(100% - ${sidebarOpen ? "200px" : "60px"})`,
        marginLeft: sidebarOpen ? "200px" : "60px",
        transition: "width 0.3s ease, margin-left 0.3s ease",
        boxShadow: "0px 4px 16px rgba(0,0,0,0.01)",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Link to="/dashboard">
          <img src="/lp-logo.png" alt="Logo" style={{ width: "180px" }} />
        </Link>
        {/* Search Bar */}
        {/* <Box
          sx={{
            flexGrow: 1,
            marginLeft: 2,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <TextField
            placeholder={t('common:search')}
            variant="standard"
            inputProps={{ "aria-label": "search" }}
            size="small"
            sx={{
              width: "100%",
              "& .MuiInputBase-input::placeholder": {
                color: "grey",
                fontStyle: "italic",
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#d1d1d1",
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "black",
                borderWidth: "1px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#d1d1d1" }} />
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

         
          <div>Filtered Files: {filteredFiles.length}</div>
          {console.log("filter files chekcing", filteredFiles)}
          <div>Filtered Relationships: {filteredRelationships?.length}</div>
          <div>Filtered Documents: {filteredDocuments.length}</div>
          <div>Filtered Appointments: {filteredAppointments.length}</div>
          <div>Filtered Tasks: {filteredTasks.length}</div>
          <div>Filtered Timesheets: {filteredTimesheets.length}</div>
          <div>Filtered Sales Documents: {filteredSalesDocuments.length}</div>
          <div>Filtered Sales Payments: {filteredSalesPayments.length}</div>
        </Box> */}
        <Box
          sx={{
            flexGrow: 1,
            marginLeft: 2,
            display: "flex",
            justifyContent: "center",
            position: "relative", // Required for absolute positioning of the dropdown
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
          }}
          ref={searchBoxRef}
        >
          {/* Search Bar */}
          <TextField
            placeholder={t('navigation:search.placeholder')}
            variant="standard"
            inputProps={{ "aria-label": t('navigation:search.placeholder') }}
            size="small"
            sx={{
              width: "100%",
              "& .MuiInputBase-input::placeholder": {
                color: "grey",
                fontStyle: "italic",
                fontSize: "11.5px",
                fontFamily:
                  "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#d1d1d1",
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "black",
                borderWidth: "1px",
              },
              fontFamily:
                "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#d1d1d1" }} />
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          {/* Search Results Dropdown */}
          {searchTerm && ( // Only show results if there's a search term
            <Box
              sx={{
                position: "absolute", // Position the dropdown absolutely
                top: "100%", // Position it below the search bar
                left: 0,
                right: 0,
                zIndex: 9999, // Ensure the dropdown appears above other content
                backgroundColor: "white", // Background color for the dropdown
                border: "1px solid #d1d1d1", // Add a border
                borderRadius: "4px", // Rounded corners
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Add a shadow for better visibility
                marginTop: 1, // Add some spacing between the search bar and dropdown
                paddingBottom: "1rem",
                maxHeight: "300px", // Limit the height of the dropdown
                overflowY: "auto", // Add a scrollbar if content overflows
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar initially
                },
                "&:hover::-webkit-scrollbar": {
                  display: "block",
                },
                fontFamily:
                  "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              }}
            >
              {/* Filtered Files */}
              {filteredFiles.length > 0 && (
                <Box sx={{ padding: 1, paddingBottom: 0 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "600",
                      color: "rgb(117, 117, 117)",
                      fontSize: "8px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      lineHeight: "20px",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "1.8px",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <FolderOpenOutlinedIcon
                      sx={{ marginRight: 1, fontSize: "0.8rem" }}
                    />
                    {t('navigation:search.files')}
                  </Typography>
                  {filteredFiles.map((file) => (
                    <Typography
                      key={file._id}
                      sx={{
                        marginLeft: 1,
                        fontSize: "11.5px",
                        fontFamily:
                          "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
                        cursor: "pointer",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "rgb(35,35,35)",
                        padding: "4px 8px", // Add padding for better visibility
                        borderRadius: "4px", // Round corners for better appearance
                        transition: "background-color 0.2s ease-in-out", // Smooth transition effect
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 255, 0.1)", // Light blue background on hover
                        },
                      }}
                      onClick={() => navigate(`/files/${file._id}/overview`)}
                    >
                      {`${file.fileNo}  ${file.name}`}
                    </Typography>
                  ))}
                </Box>
              )}

              {/* Filtered Relationships */}
              {filteredRelationships?.length > 0 && (
                <Box sx={{ marginBottom: 0, padding: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "600",
                      color: "rgb(117, 117, 117)",
                      fontSize: "8px",
                      letterSpacing: "1px",
                      textTransform: "uppercase",
                      lineHeight: "20px",
                      display: "flex",
                      alignItems: "center",
                      marginTop: "1.8px",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <PersonOutlineOutlinedIcon
                      sx={{ marginRight: 1, fontSize: "0.8rem" }}
                    />
                    {t('navigation:search.relationships')}
                  </Typography>
                  {filteredRelationships.map((relationship) => (
                    <Box
                      key={relationship._id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        transition: "background-color 0.2s ease-in-out",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 255, 0.1)",
                        },
                      }}
                      onClick={() =>
                        navigate(`/relationships/${relationship._id}`)
                      }
                    >
                      {/* Avatar */}
                      <Avatar
                        alt={
                          relationship?.firstName || relationship?.businessName
                        }
                        src={relationship.avatar ? relationship.avatar : ""}
                        sx={{
                          // fontFamily: '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                          fontSize: "7.8px",
                          height: "1rem",
                          width: "1rem",
                          marginRight: "0.2rem",
                          fontWeight: "bold",
                          // backgroundColor: relationship.avatar
                          //   ? "transparent"
                          //   : stringToColor(relationship.firstName || relationship.businessName),
                          color: "#fff",
                          // fontWeight: relationship?.businessName ? "600" : "400"
                        }}
                      >
                        {!relationship.avatar && (
                          <>
                            {relationship.firstName
                              ? relationship.firstName.charAt(0)
                              : ""}
                            {relationship.businessName
                              ? relationship.businessName.charAt(0)
                              : relationship.lastName
                              ? relationship.lastName.charAt(0)
                              : ""}
                          </>
                        )}
                      </Avatar>

                      {/* Relationship Name */}
                      <Typography
                        sx={{
                          fontSize: "11.5px",
                          fontFamily:
                            "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
                          lineHeight: "20px",
                          fontWeight: "400",
                          color: "rgb(35,35,35)",
                        }}
                      >
                        {relationship.contractType === "Individual"
                          ? `${relationship.firstName || ""} ${
                              relationship.middleName || ""
                            } ${relationship.lastName || ""}`
                          : relationship.businessName || ""}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}

              {/* {
                console.log("filtered documents search", filteredDocuments.length)
              } */}

              {/* Filtered Documents */}
              {/* {filteredDocuments.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Documents
                  </Typography>
                  {filteredDocuments.map((document) => (
                    <Typography key={document._id} sx={{ marginLeft: 1 }}>
                      {document.title}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* Filtered Appointments */}
              {/* {filteredAppointments.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Appointments
                  </Typography>
                  {filteredAppointments.map((appointment) => (
                    <Typography key={appointment._id} sx={{ marginLeft: 1 }}>
                      {appointment.name}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* Filtered Tasks */}
              {/* {filteredTasks.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Tasks
                  </Typography>
                  {filteredTasks.map((task) => (
                    <Typography key={task._id} sx={{ marginLeft: 1 }}>
                      {task.name}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* Filtered Timesheets */}
              {/* {filteredTimesheets.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Timesheets
                  </Typography>
                  {filteredTimesheets.map((timesheet) => (
                    <Typography key={timesheet._id} sx={{ marginLeft: 1 }}>
                      {timesheet.name}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* Filtered Sales Documents */}
              {/* {filteredSalesDocuments.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Sales Documents
                  </Typography>
                  {filteredSalesDocuments.map((salesDocument) => (
                    <Typography key={salesDocument._id} sx={{ marginLeft: 1 }}>
                      {salesDocument.name}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* Filtered Sales Payments */}
              {/* {filteredSalesPayments.length > 0 && (
                <Box sx={{ marginBottom: 2, padding: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Sales Payments
                  </Typography>
                  {filteredSalesPayments.map((salesPayment) => (
                    <Typography key={salesPayment._id} sx={{ marginLeft: 1 }}>
                      {salesPayment.name}
                    </Typography>
                  ))}
                </Box>
              )} */}

              {/* No Results Found */}
              {filteredFiles.length === 0 &&
                filteredRelationships?.length === 0 &&
                filteredDocuments.length === 0 &&
                filteredAppointments.length === 0 &&
                filteredTasks.length === 0 &&
                // filteredTimesheets.length === 0 &&
                filteredSalesDocuments.length === 0 &&
                filteredSalesPayments.length === 0 && (
                  <Typography
                    variant="body2"
                    sx={{ fontStyle: "italic", color: "grey", padding: 1 }}
                  >
                    {t('navigation:search.noResults')}
                  </Typography>
                )}

              <Typography
                variant="body2"
                sx={{
                  fontStyle: "italic",
                  color: "rgb(0, 91, 146)", // Light blue text color
                  padding: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: 600,
                  borderRadius: "4px", // Rounded corners
                  transition: "background-color 0.2s ease-in-out", // Smooth hover effect
                  cursor: "pointer", // Makes it clickable
                  textDecoration: "none", // Remove underline
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 255, 0.1)", // Light blue hover background
                  },
                }}
                component={Link}
                to="/search-results"
                state={{
                  filteredFiles,
                  filteredRelationships,
                  filteredDocuments,
                  filteredTasks,
                  filteredAppointments,
                  filteredTimesheets,
                  searchTerm,
                }}
              >
                {t('navigation:search.results')} <span style={{ marginLeft: "8px" }}>→</span>
              </Typography>
            </Box>
          )}
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          {/* <FormControl variant="standard" sx={{ width: "175px" }}>
            <CurrentWorkingFile
              options={filteredFiles2}
              value={
                filteredFiles2?.find((file) => file._id === selectedCaseId) ||
                null
              }
              onChange={handleCaseChange2}
              label="Current working file"
              name="case"
            />
          </FormControl> */}
          {/* <StartTimerButton /> */}
        </Box>
        <Box>
          <StartTimerButton />
        </Box>
        <Box>
          <LanguageSelector />
        </Box>
        <>
          <IconButton
            color="inherit"
            onClick={handleOpenMenu}
            disableRipple
            sx={{
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Badge
              badgeContent={unreadCount}
              color="error"
              sx={{
                "& .MuiBadge-badge": {
                  minWidth: "15px",
                  height: "15px",
                  padding: 0,
                  fontSize: "8.5px",
                  // Additional properties if desired
                },
              }}
            >
              <NotificationsNoneIcon
                sx={{
                  marginLeft: "5px",
                  color: "rgb(53, 53, 53)",
                  fontSize: 20,
                }}
              />
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            sx={{
              borderRadius: 0,
              "& .MuiPaper-root": {
                borderRadius: 0,
                boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
                minWidth: "255px",
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <NotificationsNoneIcon
                sx={{
                  marginLeft: "10px",
                  color: "rgb(53, 53, 53)",
                  fontSize: 20,
                }}
              />

              <Typography
                variant="subtitle2"
                sx={{
                  color: "rgb(53, 53, 53)",
                  fontFamily:
                    '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                  fontSize: "13.5px",
                  fontWeight: 600,
                  height: "13.5px",
                  lineHeight: "13.5px",
                  padding: "5px",
                  paddingRight: "15px",
                }}
              >
                {t('common:notifications')}
              </Typography>
              <Badge
                badgeContent={unreadCount}
                color="error"
                sx={{
                  "& .MuiBadge-badge": {
                    minWidth: "10px",
                    padding: "2px 6px",
                    height: "12px",
                    fontSize: "8.25px",

                    // Additional properties if desired
                  },
                }}
              ></Badge>
            </Box>
            {notifications.map((notif) => (
              <MenuItem
                key={notif._id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  border: "1px solid rgb(218, 218, 218)",
                  margin: "10px 15px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "rgb(117, 117, 117)",
                      fontFamily:
                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                      fontSize: "9px",
                      fontWeight: 400,
                      height: "13.5px",
                      lineHeight: "13.5px",
                    }}
                  >
                    {format(new Date(notif.createdAt), "d MMM. yyyy, HH:mm")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "rgb(117, 117, 117)",
                      fontFamily:
                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                      fontSize: "9px",
                      fontWeight: 400,
                      height: "13.5px",
                      lineHeight: "13.5px",
                    }}
                  >
                    {notif.type}
                  </Typography>
                </Box>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "rgb(53, 53, 53)",
                      display: "block",
                      fontFamily:
                        '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                      fontSize: "10.5px",
                      fontWeight: 600,
                      height: "13.5px",
                      lineHeight: "13.5px",
                    }}
                  >
                    {notif.subject}
                  </Typography>
                  {notif.type === "File" && notif.file && (
                    <Typography
                      variant="body2"
                      onClick={() => handleNavigation(notif.file._id)}
                      sx={{
                        color: "rgb(0, 91, 146)",
                        cursor: "pointer",
                        display: "inline",
                        fontFamily:
                          '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                        fontFeatureSettings: "normal",
                        fontKerning: "auto",
                        fontOpticalSizing: "auto",
                        fontSize: "10.5px",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {notif.file.fileNo} {notif.file.name}
                    </Typography>
                  )}
                  {notif.type === "Timesheet" && notif.file && (
                    <Typography
                      variant="body2"
                      onClick={() => {
                        handleCloseMenu();
                        navigate("/timesheets/create", {
                          state: { caseId: notif.file?._id || notif.file },
                        });
                      }}
                      sx={{
                        color: "rgb(0, 91, 146)",
                        cursor: "pointer",
                        display: "inline",
                        fontFamily:
                          '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                        fontSize: "10.5px",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {t("navigation:notifications.openTimesheet") || "Open timesheet"}
                    </Typography>
                  )}
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Typography
                      onClick={() => handleIgnore(notif._id)}
                      sx={{
                        color: "rgb(0, 91, 146)",
                        cursor: "pointer",
                        display: "inline",
                        fontFamily:
                          '"Fira Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
                        fontFeatureSettings: "normal",
                        fontKerning: "auto",
                        fontOpticalSizing: "auto",
                        fontSize: "10.5px",
                        marginTop: 1,
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {t('navigation:notifications.ignore')}
                    </Typography>
                  </Box>
                </div>
              </MenuItem>
            ))}
          </Menu>
        </>
        <IconButton
          color="inherit"
          sx={{ borderRadius: 0 }}
          onClick={handleProfileClick}
        >
          <Avatar
            alt={user?.firstName}
            src={user?.avatar ? user?.avatar : "/static/images/avatar/1.jpg"}
            style={{ width: "20px", height: "20px", marginLeft: "5px" }}
          />
          <Typography
            variant="body1"
            sx={{
              ...smallBold,
              marginLeft: "10px",
              textTransform: "capitalize",
              fontSize: "10.5px",
              fontWeight: 600,
              fontFamily:
                "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            }}
          >
            {user?.firstName} {user?.lastName}
          </Typography>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
